import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param payload
 * @param poId
 */
class BulkPOServices {
  /**
   * @param page
   * @param orgId
   * @param poId
   * @param tenantId
   * @param sellerId
   * @param tenantSellerId
   * @param onDate
   * @param fromDate
   * @param toDate
   * @param limit
   * @param roleId
   * @param poNumber
   * @param searchKeyword
   * @param status
   * @return {Promise<*>}
   */
     getBulkPO = async (orgId, bulkPOType, status, page, limit, searchKeyword) => {
       let url = `${Constants.BULK_PO}?`;
       if (orgId) url += `org_id=${orgId}&`;
       if (bulkPOType) url += `type=${bulkPOType}&`;
       if (status) url += `status=${status}&`;
       if (page) url += `page=${page}&`;
       if (limit) url += `limit=${limit}&`;
       if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

       const orgBulkPO = await Helpers.get({ url });
       return orgBulkPO;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     createBulkPO = async (payload) => {
       const addedProduct = await Helpers.post({
         url: Constants.BULK_PO,
         data: payload,
       });
       return addedProduct;
     }

     /**
      *
      * @param payload
      * @return {Promise<*>}
      */
     updateBulkPO = async (payload) => {
       const addedProduct = await Helpers.put({
         url: Constants.BULK_PO,
         data: payload,
       });
       return addedProduct;
     }

     /**
     *
     * @param payload
     * @return {Promise<*>}
     */
       updateBulkPOStatus = async (payload) => {
         const updatedBulkPO = await Helpers.post({
           url: Constants.UPDATE_BULK_PO_STATUS,
           data: payload,
         });
         return updatedBulkPO;
       }

       /**
      * @param orgId
      * @param type
      * @param bulkPoId
      * @return {Promise<*>}
      */
  getBulkPOById = async (orgId, bulkPOType, bulkPoId) => {
    let url = `${Constants.BULK_PO}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (bulkPOType) url += `type=${bulkPOType}&`;
    if (bulkPoId) url += `blanket_po_id=${bulkPoId}&`;

    const selectedBulkPO = await Helpers.get({ url });
    return selectedBulkPO;
  }

     /**
     *
     * @param payload
     * @return {Promise<*>}
     */
     deleteBulkPO = async (payload) => {
       const deleteBulkPO = await Helpers.delete({
         url: Constants.BULK_PO,
         data: payload,
       });
       return deleteBulkPO;
     }
}
export default new BulkPOServices();
